import { useQuery } from "@tanstack/react-query";
import { useSelector } from "react-redux";
import { apiRequest } from "./api";

// get Token
import useAuthToken from "../../Hooks/useAuthToken";

export const useCreateRole = () => {
  const token = useAuthToken();
  const createRole = async (credentials) => {
    if (!credentials) {
      throw new Error("Please provide credentials");
    }
    return apiRequest("post", "/api/role", credentials, token);
  };

  return createRole;
};

export const useGetRole = () => {
  const token = useAuthToken();
  const getRole = async () => {
    if (!token) {
      throw new Error("Token is missing");
    }
    return apiRequest("get", "/api/role", null, token);
  };

  return getRole;
};

export const useSingleUser = () => {
  const token = useAuthToken();
  const getSingleUser = async () => {
    if (!token) {
      throw new Error("Token is missing");
    }
    return apiRequest("get", "/api/user/single", null, token);
  };

  return getSingleUser;
};

// export const useGetCategoryById = (id) => {
//   const { client } = useSelector((state) => state.client);

//   // Function to fetch category data
//   const getCategoryById = async () => {
//     if (!client.clientloginToken) {
//       throw new Error('Token is missing');
//     }

//     const response = await apiRequest(
//       'get',
//       `/api/category/${id}`,
//       null,
//       client.clientloginToken
//     );

//     return response;
//   };
//   return useQuery({
//     queryKey: ['single-category', id],
//     queryFn: getCategoryById,
//     enabled: !!id,
//   });
// };

export const useUpdateUser = (id) => {
  const token = useAuthToken();

  const updateUser = async (formData) => {
    if (!token) {
      throw new Error("Token is missing");
    }
    const response = await apiRequest(
      "patch",
      `/api/user/${id}`,
      formData,
      token
    );

    return response;
  };

  return updateUser;
};
